export default from './MobileCalculationsResult';



// WEBPACK FOOTER //
// ./src/sharedComponents/MothlyPaymentCalculator/components/MobileCalculationsResult/index.js